export function domReady(fn) {
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    return fn()
  }

  document.addEventListener("DOMContentLoaded", fn, false)
}

export function init(activeModules) {
  Object.keys(activeModules).forEach((moduleName) => {
    if (!!activeModules[moduleName].init) {
      activeModules[moduleName].init()
    }
  })
}

/**
 * A simple Redux-like state management implementation
 *
 * @param {function} reducer The custom reducer.
 * @returns {function} unsubscribe Remove listener.
 */
export function createStore(reducer) {
  let listeners = []
  let currentState = reducer(undefined, {})

  return {
    getState: () => currentState,
    dispatch: (action) => {
      currentState = reducer(currentState, action)

      listeners.forEach((listener) => {
        listener()
      })
    },
    subscribe: (newListener) => {
      listeners.push(newListener)

      const unsubscribe = () => {
        listeners = listeners.filter((l) => l !== newListener)
      }

      return unsubscribe
    },
  }
}

export function getCookie(name) {
  var nameEQ = name + "="
  var ca = document.cookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == " ") c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function setCookie(name, value, options = {}) {
  options = {
    path: "/",
    ...options,
  }

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString()
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value)

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey
    let optionValue = options[optionKey]
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue
    }
  }

  document.cookie = updatedCookie
}